import * as yup from "yup";
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from "@Shared/utils/validationSchema";

export interface ITransactionsFormMeta {
    emitterBank ?: FormInputMeta;
    acquirerBank ?: FormInputMeta;
    operationType: FormInputMeta;
    usageCode: FormInputMeta;
    startDate: FormInputMeta;
    endDate: FormInputMeta;

    schema: any;
}

const transactionsFormMeta = {} as ITransactionsFormMeta;

transactionsFormMeta.emitterBank = {
    name: "emitterBank",
    type: "select",
    label: "Banque Emetteur",
    placeholder: "",
    validation: yup.string(),
};

transactionsFormMeta.acquirerBank = {
    name: "acquirerBank",
    type: "select",
    label: "Banque Acquéreur",
    placeholder: "",
    validation: yup.string(),
};

transactionsFormMeta.operationType = {
    name: "operationType",
    type: "select",
    label: "Type Opération",
    placeholder: "",
    validation: yup.string(),
};

transactionsFormMeta.usageCode = {
    name: "usageCode",
    type: "select",
    label: "Usage Code",
    placeholder: "",
    validation: yup.string(),
};

transactionsFormMeta.startDate = {
    name: "startDate",
    type: "date",
    label: "Date Début",
    placeholder: "",
    validation: yup.date(),
};

transactionsFormMeta.endDate = {
    name: "endDate",
    type: "date",
    label: "Date Fin",
    placeholder: "",
    validation: yup.date(),
};


transactionsFormMeta.schema = yup.object().shape(getValidationSchema(transactionsFormMeta));

export default transactionsFormMeta;